import { render } from "./DropdownDivider.vue?vue&type=template&id=6c57cb73"
import script from "./DropdownDivider.vue?vue&type=script&lang=js"
export * from "./DropdownDivider.vue?vue&type=script&lang=js"
script.render = render

export default script